import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useTicker } from '../../context/TickerContext';
import Ticker from '../Discover/Ticker';
import { useLayoutEffect, useState } from 'react';

const AppLayout = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();
    const { setText } = useTicker();
    const [isVisible, setIsVisible] = useState(true);
    const [pageType, setPageType] = useState<'DISCOVER' | 'OWNPROFILE' | 'SEARCH' | 'LIKED' | 'DEFAULT'>('DEFAULT');
    const user = useSelector((state: RootState) => state.auth.user);

    useLayoutEffect(() => {
        const path = location.pathname;
        const pathSegments = path.split('/').filter(Boolean);

        // Always show on Discover page with its specific message
        if (path === '/discover') {
            setPageType('DISCOVER');
            setIsVisible(true);
            return;
        }

        // Handle profile pages
        if (pathSegments[0] === 'profile' ||
            (pathSegments.length > 0 && !['discover', 'search', 'liked', 'login', 'register'].includes(pathSegments[0]))) {
            // This might be a username route for profiles
            const usernameFromPath = pathSegments[0];

            // Show ticker only on own profile
            if (user && (user.username === usernameFromPath || path === '/profile')) {
                setPageType('OWNPROFILE');
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
            return;
        }

        // Default visibility rules for other pages
        if (path.includes('/search')) {
            setPageType('SEARCH');
            setIsVisible(true);
        } else if (path.includes('/liked')) {
            setPageType('LIKED');
            setIsVisible(true);
        } else {
            setPageType('DEFAULT');
            setIsVisible(true); // Show ticker with default message on most pages
        }
    }, [location, user]);

    return (
        <>
            {children}
            <Ticker isVisible={isVisible} pageType={pageType} />
        </>
    );
};

export default AppLayout;
